import { render, staticRenderFns } from "./SessionItem.vue?vue&type=template&id=e5aaeca8&scoped=true"
import script from "./SessionItem.vue?vue&type=script&lang=js"
export * from "./SessionItem.vue?vue&type=script&lang=js"
import style0 from "./SessionItem.vue?vue&type=style&index=0&id=e5aaeca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5aaeca8",
  null
  
)

export default component.exports